import { Component } from '@angular/core';

@Component({
  selector: 'app-pagina-nao-encontrada',
  templateUrl: './pagina-nao-encontrada.component.html'
})
export class PaginaNaoEncontradaComponent  {

}
